
(function($){
    // JS
    window.Accordion = {

        // Toggle accordions
        //======================================================================
        toggleAccordion: function()
        {
        $(document).ready(function(){   
           $(document).on('click', '.dropdown-title', function(e){
                e.preventDefault();

            // cache this
            var $control = $(this);
            
            // get the current row
            var current = $control.next('.dropdown-content');
            
            // toggle the accessibility controls
            var ariaExp = Accordion.toggleAttr($control.attr('aria-expanded')),
                ariaHid = Accordion.toggleAttr(current.attr('aria-hidden'));
            
            // slide all other accordions up except this one
            //$('.dropdown-content').not(current).slideUp('fast').attr('aria-hidden', 'true');
            // then just toggle slide the current one
            current.slideToggle('fast').attr('aria-hidden', ariaHid);
            
            if($control.hasClass('subtitle')){

                $('.second_level .dropdown-content').not(current).slideUp('fast').attr('aria-hidden', 'true');
                // remove active class from all accordion triggers except the current one
                $('.dropdown-title').not(this).not('.dropdown-title.maintitle.active').removeClass('active').attr('aria-expanded', 'false');

            }else{
                
                $('.dropdown-content').not(current).slideUp('fast').attr('aria-hidden', 'true');

                // remove active class from all accordion triggers except the current one
                $('.dropdown-title').not(this).removeClass('active').attr('aria-expanded', 'false');
            }


            // then toggle the active class for the current target
            $control.toggleClass('active').attr('aria-expanded', ariaExp);
                  
           });
        });
            
        },
        // use on the definitions page
        showMoreDropDowns: function() {
            $(document).ready(function(){   
                $(document).on('click', '[data-js-button=toggle-more]', function(e){
                     e.preventDefault();

                     $(this).find('span').text(function(i, text){
                        
                        if(text == 'Show more') {
                            return 'Show less';
                        } else if(text == 'Show less') {
                            return 'Show more';
                        } else if(text == 'Visa allt') {
                            return 'Visa mindre';
                        } else if(text == 'Visa mindre') {
                            return 'Visa allt';
                        }
                    })

                    var dropdown = $(this).parent().find('.dropdown-all');

                    dropdown.slideToggle('fast');
                       
                });
             });
        },
        toggleAttr: function(attr) {
            return (attr == 'false') ? 'true' : 'false';
        }
    }
    // Run
    $(function(){
        Accordion.toggleAccordion();
        Accordion.showMoreDropDowns();
    });


}(jQuery));